module.exports = __webpack_public_path__ + "img/reg22.f3ea0c44.png";